import React, { FC } from 'react';
import classnames from 'classnames';
import Checkbox from '@src/components/Checkbox';
import { Image } from '@src/components/Image';
import { SelectSocialMediaPackageProps, SocialMediaPackageOptions } from './props';
import './styles.scss';

export const SelectSocialMediaPackage: FC<SelectSocialMediaPackageProps> = ({
  priceInEur,
  selectedPackage,
  onSelectPackage,
}) => {
  return (
    <>
      <div
        className={classnames(
          'select-social-media-package',
          selectedPackage === SocialMediaPackageOptions.SOCIAL_MEDIA && 'select-social-media-package--selected',
        )}
        onClick={() => {
          onSelectPackage(SocialMediaPackageOptions.SOCIAL_MEDIA);
        }}
      >
        <div className="select-social-media-package__header">
          <Checkbox
            style="highlighted"
            value={selectedPackage === SocialMediaPackageOptions.SOCIAL_MEDIA}
            disableStateChange
            propagateEvent
          />
          <div className="select-social-media-package__header-title">
            <h4>Recruitment campaign on Social Media</h4>
            <p>
              Build even stronger brand awareness by reaching out to a wider audience for a longer period. The Premium
              promotion lasts 10 days and includes Facebook & Instagram posts and stories.
            </p>
          </div>
          <div className="select-social-media-package__header-price">
            <span>€{priceInEur}</span>
            <span>/mo</span>
          </div>
        </div>

        <Image src="https://meetfrank-static-media.s3.amazonaws.com/images/social-media-preview.jpg" />
      </div>
      <div
        className="select-social-media-package__header-decline"
        onClick={() => {
          onSelectPackage(SocialMediaPackageOptions.SKIPPED);
        }}
      >
        <Checkbox value={selectedPackage === SocialMediaPackageOptions.SKIPPED} disableStateChange propagateEvent />
        <div className="select-social-media-package__header-title">
          <h4>No, I don’t want any extra distribution by Social Media</h4>
          <p>Your job opening will still be discoverable and users can search for it.</p>
        </div>
      </div>
    </>
  );
};
